import { Agenda } from "./agenda";
import { Session } from "./session";

interface TimeslotData {
  id?: number;
  sessionId?: number;
  agendaId?: number;
  fromDate?: string;
  toDate?: string;
  repetitionTag?: string;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  agenda?: Agenda;
  session?: Session;
}

export class Timeslot {
  public static getNonTranslatableFields(): string[] { return ['id', 'sessionId', 'agendaId', 'fromDate', 'toDate', 'repetitionTag', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'sessionId', 'agendaId', 'fromDate', 'toDate', 'repetitionTag', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  sessionId?: number;
  agendaId?: number;
  fromDate?: string;
  toDate?: string;
  repetitionTag?: string;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  agenda?: Agenda;
  session?: Session;

  public static fromAPI(data: TimeslotData): Timeslot {
    if (data.agenda) {
      data.agenda = Agenda.fromAPI(data.agenda)
    }
    if (data.session) {
      data.session = Session.fromAPI(data.session)
    }
    return new Timeslot(data);
  }

  public static fromAPIList(data: TimeslotData[]): Timeslot[] {
    return data.map((item: TimeslotData) => Timeslot.fromAPI(item));
  }

  constructor({id, sessionId, agendaId, fromDate, toDate, repetitionTag, createDate, createrId, updateDate, updaterId, deleteDate, deleterId,
              agenda, session} : TimeslotData) {
    this.id = id;
    this.sessionId = sessionId;
    this.agendaId = agendaId;
    this.fromDate = fromDate;
    this.toDate = toDate;
    this.repetitionTag = repetitionTag;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.deleteDate = deleteDate;
    this.deleterId = deleterId;

    this.agenda = agenda;
    this.session = session;
  }


  public toJson(): TimeslotData {
    return {
      id: this.id,
      sessionId: this.sessionId,
      agendaId: this.agendaId,
      fromDate: this.fromDate,
      toDate: this.toDate,
      repetitionTag: this.repetitionTag,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId
    };
  }
}
